import { Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Button } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import {getMaterialImage} from 'src/store/api/materialOperations'

function MaterialDisplay(allProps) {
  let {setProps, ...props} = allProps
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);

  
  useEffect(() => {
    if(props.open && props.materialCode?.length > 0){
      setLoading(true);
      getMaterialImage(props.materialCode)
        .then(response => {
          var fileURL = URL.createObjectURL(response.data);
          setImage(fileURL);
  
          setLoading(false);
        }).catch(error => {
          // console.log("Malzeme Resmi Açılamadı!.. " + error.message);
          setLoading(false);
        });
    }
  }, [props.open, props.materialCode])

  return (
    <Dialog
      open={(props.open)}
      // TransitionComponent={Transition}
      keepMounted
      onClose={() => setProps({...props, open: false})}>
      <DialogTitle>
        {props.materialDesc}
      </DialogTitle>
      <DialogContent>
        {loading ?
          <LinearProgress status="loading" />
          :
          <img style={{ width: '100%' }} alt='' src={image}/>}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setProps({...props, open: false})} color="primary">
          Kapat
          </Button>
      </DialogActions>
    </Dialog>
  );
}

export default MaterialDisplay;
